import React, { useState, useEffect, useRef } from 'react';

import { ActualizarFechaVencimiento } from './modalActualizarFechaVencimiento';
import { Mensaje, MensajeSiNo } from '../../../components/mensajes';

 
import useTableFijo from '../../useTableFijo';
import moment from 'moment';
import { Dimmer } from '../../spinner';
import Axios from 'axios';


const headCells = [
    { id: 'mes', label: 'MES', width: '80px', textAlign: "center",backgroundColor: " rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'fecha', label: 'FECHA', width: '80px', textAlign: "center",backgroundColor: " rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
    { id: 'accion', label: 'OPCIONES', width: '180px', textAlign: "center",backgroundColor: " rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
]


function TablaFechasVencimientoRete(props) {

    let token = localStorage.getItem('jwtToken');

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);

    const [contar, setContar] = useState(0);
    const [contar1, setContar1] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [fechaSel, setFechaSel] = useState();
    const [permiso, setPermiso] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [anio, setAnio] = useState([]);
    const [nombreMes, setNombreMes] = useState(
        ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", 
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ]);
    const cmbAnioA = useRef();

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../../src/modulos/datos');

    let heightTabla = 320;
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, heightTabla);
    const seleccionarRegistros = (anio) => {
        setActivate(true)

        let nomtab = 'fechavencimientore'
        
        let endpoint = `${op.conexion}/api/industria/allfechas?tabla=${nomtab}&anio=${anio}`;
        console.log(endpoint)

        Axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then((response) => {

            if (response.status == 200) {
                setActivate(false);

                setRecords(response.data);
                console.log(response.data)

                cmbAnioA.current.value = anio;



            }

        }).catch((error) => {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    };

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setPermiso(JSON.parse(localStorage.getItem('permisos')).accactividad);
        setFechaSistema(obj.fechasistema);
        setAnioActu(obj.anioactu);
        var nanio = []
        var aini = 2010;
        var afin = parseInt(obj.anioactu, 10);
        for (let i = 1; i <= afin - aini; i++) {
            nanio.push({ anio: aini + i });
        }

        setAnio(nanio);
  
       
        cmbAnioA.current.value = obj.anioactu;
       
       seleccionarRegistros(nanio[nanio.length - 1].anio)



    }, []);


  
    //console.log(values)




    const agregarFecha = () => {
        setOperacion(1);
        setAnioActu(cmbAnioA.current.value)
        setMostrar5(true);
    };

    const cerrarModalActualizar = () => {
        setFechaSel();
        setMostrar5(false);
        let anio = parseInt(cmbAnioA.current.value)
        seleccionarRegistros(anio)
    }

    const validarActuFecha = () => {
        setMostrar5(false);
        renderizar();
    }

    const handleCancelaCapcha = () => {
        setMostrar4(false);
    }

    const handleCloseNo = () => {
        setMostrar3(false);
    }

    const handleCloseSi = () => {
        setMostrar3(false);
        //setMostrar5(false);
        //setMostrar2(false)
        //procesarSolicitud();

    }

    const handleCloseMensa = () => {
        setMostrar(false);
        if (contar3 > 0) {
           /*  window.location.href = '/claseActividad' */
           /*  props.history.push('/claseActividad') */;
            renderizar();
        }
    }


    const renderizar = () => {
        let anio = parseInt(cmbAnioA.current.value)
        seleccionarRegistros(anio)
    }

    const seleccionarFechas = (nanio) => {
        setContar4(0);
        setContar(0);
        //setActivate(true);
      
    };

    const editarFechaVencimiento = (index) => (event) => {
        event.preventDefault();
        setOperacion(2);
        setContar(0);
        setFechaSel({
            anio: records[index].anio,
            mes: records[index].mes,
            fechaven: records[index].fechaven,
        });
        setMostrar5(true);
    };

    const eliminarFechaVencimiento = (index) => (event) => {
        event.preventDefault();
        setOperacion(3);
        setContar(0);
        setContar1(0);
        setFechaSel({
            anio: records[index].anio,
            mes: records[index].mes,
            fechaven: records[index].fechaven,
        });        
        setMostrar5(true);
    };

    const handleCmbAnio = (event) => {
        event.preventDefault();
        let anio = parseInt(cmbAnioA.current.value)
        seleccionarRegistros(anio)
    };

    return (
        <div className="card">
            <ActualizarFechaVencimiento
                show={mostrar5} titulo={titulo1} mensaje={msg1}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuFecha}
                fechasistema={fechaSistema}
                anioactual={anioActu}
                nombretab={'fechavencimientore'}
                fechaseleccionada={fechaSel}
                operacion={operacion} />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            <MensajeSiNo titulo={titulo} mensaje={msg}
                show={mostrar3}
                onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                <div className="row">
                                    <div className="row col-md-3">
                                        <div className="col-md-4">
                                            <label htmlFor="inputRitm">Año:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <select name="" ref={cmbAnioA} style={{ marginBottom: "5px" }} className="form-control form-control-sm" onChange={handleCmbAnio}>
                                                {anio && anio.map(a => (
                                                    <option key={a.anio} value={a.anio}>{a.anio}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6"></div>
                                    <div className="col-md-3 d-flex justify-content-end">
                                        <button /*disabled={permiso && permiso.substring(1, 2) !== "1"}*/ onClick={agregarFecha} style={{ marginBottom: "10px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.idactividad} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "left", width: "80px" }}>{nombreMes[item.mes-1]}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left", width: "80px" }}>{moment.utc(item.fechaven).format('DD/MM/YYYY')}</td>
                                                    <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "50px", padding: 0 }}>
                                                        <button /*style={{ pointerEvents: permiso && permiso.substring(2, 3) !== "1" ? 'none' : '' }}*/ onClick={editarFechaVencimiento(index)} className="btn btn-sm btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button /*style={{ pointerEvents: permiso && permiso.substring(3, 4) !== "1" ? 'none' : '' }}*/ onClick={eliminarFechaVencimiento(index)} className="btn btn-sm btn-danger rounded-circle"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                {/*<TblPagination />*/}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );

}

export default TablaFechasVencimientoRete;
